var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-col", { attrs: { cols: "10", sm: "8" } }, [
    _c(
      "div",
      { staticClass: "text-center" },
      [
        _c("h3", { staticClass: "title-login grey-text bold text-darken-2" }, [
          _vm._v("\n      " + _vm._s(_vm.$t("account.passwordSet")) + "\n    "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-center" }, [
          _c("img", {
            staticClass: "img-fluid",
            attrs: {
              src: require("@Shared/@Assets/img/app-flow/mail-img.svg"),
              alt: "",
            },
          }),
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("b-col", { staticClass: "footer-login", attrs: { cols: "12" } }, [
          _c("a", { attrs: { href: "#/login" } }, [
            _vm._v(_vm._s(_vm.$t("global.actions.backToLogin"))),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }